import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const appointmentService = {
    getAllAppointments,
    getAppointment,
    updateAppointment,
    updateAppointmentStatus,
    createAppointment,
    cancelAppointment, 
    rejectAppontment 
};

const MODULE = {
    APPOINTMENT: 'appointments',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllAppointments(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.APPOINTMENT}`, requestOptions)
}

export function getAppointment(id) {
    return apiHelper(API_URL).get(`/${MODULE.APPOINTMENT}/${id}`)
}

export function updateAppointment(data) {
    const requestOptions = {
        location_uuid: data.locationID,
        team_uuid: data.teamID,
        contact_method: data.contactMethod,
        customer_email: data.customerEmail,
        customer_phone_code: data.customerPhoneCode,
        customer_phone_iso: data.customerPhoneISO,
        customer_phone: data.customerPhone,
        date: data.date,
        start: data.start,
        end: data.end,
    }
    
    data.services.forEach((service, index) => {
        requestOptions.params[`menu_service_uuids[${index}][uuid]`] = service.uuid;
        requestOptions.params[`menu_service_uuids[${index}][quality]`] = service.quality;
    });

    data.packages.forEach((packageData, index) => {
        requestOptions.params[`package_uuids[${index}][uuid]`] = packageData.uuid;
        requestOptions.params[`package_uuids[${index}][quality]`] = packageData.quality;
    });

    return apiHelper(API_URL).post(`/${MODULE.APPOINTMENT}/${data.id}`, requestOptions)     
}

export function createAppointment(data) {
    const requestOptions = {
        location_uuid: data.locationID,
        team_uuid: data.teamID,
        contact_method: data.contactMethod,
        customer_email: data.customerEmail,
        customer_phone_code: data.customerPhoneCode,
        customer_phone_iso: data.customerPhoneISO,
        customer_phone: data.customerPhone,
        date: data.date,
        start: data.start,
        end: data.end,
    }
    
    data.services.forEach((service, index) => {
        requestOptions.params[`menu_service_uuids[${index}][uuid]`] = service.uuid;
        requestOptions.params[`menu_service_uuids[${index}][quality]`] = service.quality;
    });

    data.packages.forEach((packageData, index) => {
        requestOptions.params[`package_uuids[${index}][uuid]`] = packageData.uuid;
        requestOptions.params[`package_uuids[${index}][quality]`] = packageData.quality;
    });

    return apiHelper(API_URL).post(`/${MODULE.APPOINTMENT}`, requestOptions)
}

export function updateAppointmentStatus(data) {
    
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.APPOINTMENT}/${data.id}`, requestOptions)
}

export function cancelAppointment(data) {
    
    const requestOptions = {
        remark: data.remark
    }

    return apiHelper(API_URL).patch(`/${MODULE.APPOINTMENT}/${data.id}/cancel`, requestOptions)
}

export function rejectAppontment(data) {
    
    const requestOptions = {
        remark: data.remark
    }

    return apiHelper(API_URL).patch(`/${MODULE.APPOINTMENT}/${data.id}/reject`, requestOptions)
}

